import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for R5NP (Complaint Purchase Shipment Approval)
// ============================================================

export interface WriteoffItem {
  fn210_01: string;         // Shipment no (PK)
  fn210_11: string | null;  // Shipment date (ISO string)
  fn210_12: string;         // Vendor code
  fn210_23: string;         // Vendor code (short)
  vendor_name: string;      // Vendor name (from F105)
  selected: boolean;        // Selection state
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ValidateItemResponse {
  valid: boolean;
  message?: string;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const r5npApi = {
  /** Query complaint shipment items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/r5np/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Validate a single item for writeoff eligibility */
  async validateItem(shipmentNo: string): Promise<ValidateItemResponse> {
    const res = await apiClient.post('/api/r5np/validate-item', {
      shipment_no: shipmentNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected items */
  async execute(shipmentNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/r5np/execute', {
      shipment_nos: shipmentNos,
    });
    return res.data;
  },
};
